import React from 'react'
import { inject, observer } from 'mobx-react'
import Question from '../Question'

function AllMode({ surveyState }) {
  const { steps } = surveyState

  return steps.length > 0
    ? steps.map(mapped => (
        <Question key={mapped.codename} mapped={mapped} bordered inactive />
      ))
    : 'INVALID SURVEY'
}

export default inject('surveyState')(observer(AllMode))
